import { render, staticRenderFns } from "./DocumentPOSPrintTotal.vue?vue&type=template&id=75a72e70&scoped=true"
import script from "./DocumentPOSPrintTotal.vue?vue&type=script&lang=js"
export * from "./DocumentPOSPrintTotal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPOSPrintTotal.vue?vue&type=style&index=0&id=75a72e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a72e70",
  null
  
)

export default component.exports